import {
  Height,
  InfoButtonsLayout,
  InfoButtonsWidth,
  InfoMaxWidth,
  SectionLayout,
  SectionTypeEnum,
} from '@nucleus/types/web';
import { Alignment } from '@nucleus/types/web/alignment';
import { Position } from '@nucleus/types/web';
import { SectionDefaultBuilder } from '../SectionDefaultBuilder';

const builder = new SectionDefaultBuilder<SectionTypeEnum.Footer>().setStatic((config) => ({
  name: config.title,
  layout: SectionLayout.Full,
  backgroundMedia: { presetMediaKey: 'sectionBackground', presetMediaOrder: 'first' },
  blockBackgroundMedia: { presetMediaKey: 'blockBackground', presetMediaOrder: 'first' },
  colorPaletteVariation: 'variation-2',
  height: Height.Medium,
  blocks: [
    {
      brandIdentity: {
        useLogo: false,
        useText: true,
        text: '',
      },
      actions: [],
      contacts: [],
      navigation: undefined,
      legal: [
        {
          type: 'paragraph',
          fontStyle: 'paragraph1',
          children: [
            { text: 'Copyright ' },
            { type: 'parameter', fallback: '', children: [{ text: '' }], parameter: 'churchName' },
            { text: ' ' },
            { type: 'parameter', fallback: '', children: [{ text: '' }], parameter: 'currentYear' },
            { text: '' },
          ],
        },
      ],
    },
  ],
  blockLayout: config.layout,
  blockLayoutVariant: 'variant1',
  blockEnabledInfo: {
    actions: true,
    body: true,
    brandIdentity: true,
    contacts: true,
    legal: true,
    navigation: true,
  },
  blockInfoPosition: Position.Center,
  blockHeadlineAlignment: Alignment.Left,
  blockHeadlineMaxWidth: InfoMaxWidth.Medium,
  blockBodyAlignment: Alignment.Left,
  blockButtonsAlignment: Alignment.Left,
  blockButtonsLayout: InfoButtonsLayout.Vertical,
  blockButtonsWidth: InfoButtonsWidth.Auto,
  blockMediaOptions: {
    useColor: false,
    useImage: true,
    useVideo: false,
    image: {
      scale: 'cover',
      tile: 'none',
    },
    blending: {
      opacity: 1,
      blendMode: 'none',
      fade: 'none',
    },
  },
}));

export default builder.build();
